// Números no formato brasileiro e a conta digitada direto no campo (6*12, 107,64/6).

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const reais = (v) => BRL.format(Number(v) || 0);

export const numero = (v, casas = 2, { minimo = casas } = {}) =>
  (Number(v) || 0).toLocaleString("pt-BR", { minimumFractionDigits: minimo, maximumFractionDigits: casas });

// "1.234,56" → 1234.56 · "2,5" → 2.5 · "2.5" → 2.5
function lerToken(t) {
  if (t.includes(",")) return parseFloat(t.replace(/\./g, "").replace(",", "."));
  if ((t.match(/\./g) || []).length > 1) return parseFloat(t.replace(/\./g, ""));
  return parseFloat(t);
}

export const temConta = (texto) => /\d\s*[-+*/x×÷]\s*[\d(]/i.test(String(texto || ""));

// Avalia + − × ÷ e parênteses sem eval. Devolve null se a conta estiver incompleta.
export function calcular(texto) {
  const s = String(texto || "").replace(/\s+/g, "").replace(/[x×]/gi, "*").replace(/÷/g, "/").replace(/−/g, "-");
  if (!s) return null;
  const tokens = s.match(/\d[\d.,]*|[-+*/()]/g);
  if (!tokens || tokens.join("") !== s) return null;
  let i = 0;
  const fator = () => {
    const t = tokens[i];
    if (t === "(") {
      i += 1;
      const v = soma();
      if (tokens[i] !== ")") throw new Error("parêntese");
      i += 1;
      return v;
    }
    if (t === "-") { i += 1; return -fator(); }
    if (t === undefined || /[-+*/()]/.test(t)) throw new Error("incompleta");
    i += 1;
    return lerToken(t);
  };
  const produto = () => {
    let v = fator();
    while (tokens[i] === "*" || tokens[i] === "/") {
      const op = tokens[i]; i += 1;
      const d = fator();
      v = op === "*" ? v * d : v / d;
    }
    return v;
  };
  const soma = () => {
    let v = produto();
    while (tokens[i] === "+" || tokens[i] === "-") {
      const op = tokens[i]; i += 1;
      const d = produto();
      v = op === "+" ? v + d : v - d;
    }
    return v;
  };
  try {
    const v = soma();
    return i === tokens.length && Number.isFinite(v) ? v : null;
  } catch {
    return null;
  }
}
